import React from "react";
import { Modal, Form } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import ChooseTemplate from "./chooseTemplate";
import AdjustTimeAndText from "./adjustTimeAndText";
import SelectGroup from "./selectGroup";
import Confirmation from "./confirmation";
import useCreateAlert from "./useCreateAlert";

const Modal4CreateAlert = () => {
  const {
    handleClose,
    isEmergencyAlert,
    selectedTab,
    setSelectedTab,
    isTemplateTabFilled,
    displayTemplates,
    templateLookup,
    isDateTimeTabFilled,
    isSelectGroupsTabFilled,
    selectedTemplate,
    handleEmergencyTabSelected,
    handleTemplateIdChange,
    handleNextTab,
    handleDateTimeFieldEmpty,
    handleSelectGroupFieldEmpty,
    handleCreateAlert,
    handleQuickAlert,
    handleEditQuickAlert,
    adjustTimeAndTextState,
    setAdjustTimeAndTextState,
    selectGroupState,
    setSelectGroupState,
    isTemplateDivSelected,
    handleTemplateClick,
    confirmationBoxText,
    getTabClassName,
    getFormClassName,
    handleSelectedTab,
    adjustTimeAndTextStateRef,
    isEdit,
    isModalActive,
    isQuickAlertMode,
    isEditQuickAlertMode,
    saveAsQuickAlert,
    setSaveAsQuickAlert,
    buttonLabelText,
    setButtonLabelText,
    allClearChecked,
    allClearTime,
    setAllClearTime,
    setAllClearChecked,
    quickAlertButtonLabelError,
    isQuickAlertsValidationLoading,
  } = useCreateAlert();
  return (
    <>
      <Modal
        show={isModalActive}
        onHide={handleClose}
        className="modal-container modal4-create-alerts"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditQuickAlertMode
              ? `Edit Quick Alert (${selectedTab + 1}/4)`
              : isQuickAlertMode
                ? `Create Quick Alert (${selectedTab + 1}/4)`
                : isEdit
                  ? `Edit Alert (${selectedTab + 1}/4)`
                  : `Create Alert (${selectedTab + 1}/4)`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alerts-tabs-container">
            <Tabs
              className="CreateEmergencyTabs"
              selectedIndex={selectedTab}
              onSelect={(index) => handleSelectedTab(index)}
            >
              <TabList>
                <Tab className={getTabClassName(0)}>
                  <div className="tab-title">
                    <Form.Check
                      type="radio"
                      label=""
                      name="radioGroup"
                      id="ChooseTemplate"
                      checked={selectedTab >= 0}
                      className={getFormClassName(0)}
                    />
                    <span>Choose Template</span>
                  </div>
                </Tab>
                <Tab
                  disabled={!isTemplateTabFilled}
                  className={getTabClassName(1)}
                >
                  <div className="tab-title">
                    <Form.Check
                      type="radio"
                      label=""
                      name="radioGroup"
                      id="ChooseTemplate"
                      checked={selectedTab >= 1}
                      className={getFormClassName(1)}
                    />
                    <span>Adjust Time & Text</span>
                  </div>
                </Tab>
                <Tab
                  disabled={!isDateTimeTabFilled}
                  className={getTabClassName(2)}
                >
                  <div className="tab-title">
                    <Form.Check
                      type="radio"
                      label=""
                      name="radioGroup"
                      id="ChooseTemplate"
                      checked={selectedTab >= 2}
                      className={getFormClassName(2)}
                    />
                    <span>Select Groups</span>
                  </div>
                </Tab>
                {/* {!isEmergencyAlert && ( */}
                <Tab
                  disabled={!isSelectGroupsTabFilled || !isDateTimeTabFilled}
                  className={getTabClassName(3)}
                >
                  <div className="tab-title">
                    <Form.Check
                      type="radio"
                      label=""
                      name="radioGroup"
                      id="ChooseTemplate"
                      checked={selectedTab >= 3}
                      className={getFormClassName(3)}
                    />
                    <span>Confirmation</span>
                  </div>
                </Tab>
                {/* )} */}
              </TabList>

              <TabPanel className="create-emergency-tab-content">
                <ChooseTemplate
                  onNextTab={handleNextTab}
                  onClose={handleClose}
                  isTemplateDivSelected={isTemplateDivSelected}
                  handleTemplateClick={handleTemplateClick}
                  isTemplateTabFilled={isTemplateTabFilled}
                  displayTemplates={displayTemplates}
                />
              </TabPanel>
              <TabPanel>
                <AdjustTimeAndText
                  onNextTab={handleNextTab}
                  onClose={handleClose}
                  selectedTemplate={selectedTemplate}
                  handleTemplateClick={handleTemplateClick}
                  isDateTimeFieldEmpty={handleDateTimeFieldEmpty}
                  adjustTimeAndTextState={adjustTimeAndTextState}
                  setAdjustTimeAndTextState={setAdjustTimeAndTextState}
                  adjustTimeAndTextStateRef={adjustTimeAndTextStateRef}
                  isEdit={isEdit}
                  isQuickAlert={isQuickAlertMode}
                  isEditQuickAlert={isEditQuickAlertMode}
                  allClearChecked={allClearChecked}
                  setAllClearCheckbox={setAllClearChecked}
                  allClearTime={allClearTime}
                  setAllClearTime={setAllClearTime}
                  templateLookup={templateLookup}
                />
              </TabPanel>
              <TabPanel>
                <SelectGroup
                  onCreateAlert={handleCreateAlert}
                  // isEmergencyAlert={isEmergencyAlert}
                  onNextTab={handleNextTab}
                  onClose={handleClose}
                  isSelectGroupFieldEmpty={handleSelectGroupFieldEmpty}
                  selectGroupState={selectGroupState}
                  setSelectGroupState={setSelectGroupState}
                  isEditAlert={isEdit}
                  isQuickAlert={isQuickAlertMode}
                  isEditQuickAlert={isEditQuickAlertMode}
                  alertMessage={adjustTimeAndTextState?.alertMessageState}
                  alertHeading={adjustTimeAndTextState?.alertHeadingState}
                />
              </TabPanel>
              {/* {!isEmergencyAlert && ( */}
              <TabPanel>
                <Confirmation
                  onClose={handleClose}
                  onCreateAlert={handleCreateAlert}
                  onQuickAlert={handleQuickAlert}
                  onEditQuickAlert={handleEditQuickAlert}
                  isEditAlert={isEdit}
                  isQuickAlert={isQuickAlertMode}
                  isEditQuickAlert={isEditQuickAlertMode}
                  confirmationBoxText={confirmationBoxText}
                  allClearChecked={allClearChecked}
                  alertMessage={adjustTimeAndTextState.alertMessageState}
                  alertHeading={adjustTimeAndTextState.alertHeadingState}
                  saveAsQuickAlertChecked={saveAsQuickAlert}
                  setSaveAsQuickAlertChecked={setSaveAsQuickAlert}
                  buttonLabelText={buttonLabelText}
                  setButtonLabelText={setButtonLabelText}
                  quickAlertButtonLabelError={quickAlertButtonLabelError}
                  isQuickAlertsValidationLoading={
                    isQuickAlertsValidationLoading
                  }
                />
              </TabPanel>
              {/* )} */}
            </Tabs>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

Modal4CreateAlert.defaultProps = {
  isEdit: false,
  alertData: null,
};

export default Modal4CreateAlert;
